import {
  Component,
  OnInit,
} from '@angular/core';
import {ApiService} from '../../shared/services/api.service';
import {InternalService} from '../../shared/services/internal.service';

import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';


@Component({
  selector: 'app-contact',
  templateUrl: 'contact.component.html',
  styleUrls: ['contact.component.css'],
})
export class ContactComponent implements OnInit {
  disable:any =false;
  name: any = '';
  email: any = '';
  message: any = '';

  constructor(
    public apiService: ApiService,
    private router: Router,
    public translate:TranslateService,
    public toastr: ToastrService,
    public internalService: InternalService
  ) {
  }

  ngOnInit() {
    document.querySelector('#nav').scrollIntoView({ behavior: 'smooth', block: 'start' });
  }




  sendFeedback() {
    if (!this.email || !this.name || !this.message ) {
      this.translate.get('PleaseFillAllRequiredFiled').subscribe(res=>{
        this.toastr.error(res);
      })
      return false;
    }
    if (!this.validateEmail(this.email)) {
      this.translate.get('EnterTheCorrectEmailAddress').subscribe(res=>{
        this.toastr.error(res);
      })
      return false;
    }

    const body = {
      email: this.email,
      name: this.name,
      text: this.message,
      UserLanguageID: Number(localStorage.getItem('lang'))
    };
    // console.log(body)

    // this.disable =true;
    // this.translate.get('SuccessfullyReceived').subscribe(response =>{
    //   this.toastr.error(response);
    // })
    this.apiService.sendFeedback(body).subscribe((res: any) => {
      // console.log(res);
      if(res.stu===1){
        this.disable =true;
        this.translate.get('SuccessfullyReceived').subscribe(response =>{
          this.toastr.success(response);
        })
      }
    });
  }
  validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

}
